import i18n from 'i18next';
import common_en from '../i18n/en.json';
import common_de from '../i18n/de.json';
import common_ja from '../i18n/ja.json';
import common_fr from '../i18n/fr.json';
import common_it from '../i18n/it.json';
import common_ko from "../i18n/ko.json";
import common_vi from "../i18n/vi.json";
import common_zh from "../i18n/zh.json";
import common_th from "../i18n/th.json";
import common_fi from "../i18n/fi.json";
import common_nl from "../i18n/nl.json";
import common_tr from "../i18n/tr.json";
import common_es from "../i18n/es.json";


import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const resources = {
  en: {
    common: common_en,
  },
  de: {
    common: common_de,
  },
  ja: {
    common: common_ja,
  },
  it: {
    common: common_it,
  },
  fr: {
    common: common_fr,
  },
  ko: {
    common: common_ko,
  },
  vi: {
    common: common_vi,
  },
  zh: {
    common: common_zh,
  },
  th: {
    common: common_th,
  },
  fi: {
    common: common_fi,
  },
  nl: {
    common: common_nl,
  },
  tr: {
    common: common_tr,
  },
  es: {
    common: common_es,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next).init({
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    detection: {
      caches: [],
    },
    resources
  });